import PropTypes from 'prop-types';

type MapType = {
  [key: string]: string;
};

export const FILE_HANDLER_VARIANTS = {
  DEFAULT: 'default',
  LOADING: 'loading',
  SUCCESS: 'success',
  ERROR: 'error',
  REMOVED: 'removed',
} as MapType;

type Variants = typeof FILE_HANDLER_VARIANTS;
export type Variant = Variants[keyof Variants];

export const variantPropType = PropTypes.oneOf<Variant>(
  Object.values(FILE_HANDLER_VARIANTS)
);
